import { create } from 'zustand'
import api from '../services/api'

/**
 * Feature flags letti dal backend dopo il login.
 * Il modulo Controllo di Gestione è invisibile se controllingEnabled=false.
 */
const useFeaturesStore = create((set, get) => ({
  controllingEnabled: false,
  loaded: false,

  load: async () => {
    if (get().loaded) return
    try {
      const r = await api.get('/core/features/')
      set({
        controllingEnabled: !!r.data.controlling_enabled,
        loaded: true,
      })
    } catch {
      set({ loaded: true })
    }
  },

  reset: () => set({ controllingEnabled: false, loaded: false }),
}))

export default useFeaturesStore
